import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';

import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { DatatableUtilsModule } from '../../../shared/components/datatable-utils/datatable-utils.module';
import { CopHelperComponent } from './cop-helper.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { LangSwitcherModule } from '../../../shared/components/lang-switcher/lang-switcher.module';
import { CopBrokerHelperComponent } from './cop-broker-helper/cop-broker-helper.component';

const routes: Routes = [
    {
        path: '',
        component: CopHelperComponent
    },
    {
        path: 'broker',
        component: CopBrokerHelperComponent
    },
    {
        path: 'broker/:id',
        component: CopHelperComponent
    },
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatDialogModule,
        TranslateModule,
        NgxDatatableModule,
        DatatableUtilsModule,
        AngularFirestoreModule,
        RouterModule.forChild(routes),
        NgScrollbarModule,
        LangSwitcherModule
    ],
    declarations: [
        CopHelperComponent,
        CopBrokerHelperComponent
    ],
    exports: [
        CopHelperComponent,
        CopBrokerHelperComponent
    ]
})
export class CopHelperModule { }
